import {createApp} from "vue";
const axios = require('axios');

export default {
    name: 'price-estimate',
    _el: null,

    init() {
        this._el = document.getElementById('js_priceEstimate');

        if (this._el) {
            this.run();
        }
    },

    run ()
    {
        const queryString = window.location.search;

        let regNumber   = null;
        let name        = null;
        let email       = null;
        let phone       = null;
        let street      = null;
        let zipcode     = null;
        let city        = null;
        let mileage     = null;

        if (queryString.search('test=reg_number') != -1) {
            regNumber = 'st93657';
            name    = 'Ola Nordmann';
            email   = 'test@example.com';
            phone   = '12345679';
            street  = 'Kanonveien 9';
            zipcode = '0001';
            city    = 'Olso';
            mileage = '123456';
        }

        createApp({
            delimiters: ['@{', '}'],

            data() {
             return {
                    brand       :  '',
                    brandList   : [],
                    city        : city,
                    classAttachment : '',
                    email       : null,
                    equipment   : [],
                    equipmentDetailsToggled : false,
                    equipmentList   : [],
                    fuel        : "",
                    gdpr        : null,
                    host        : null,
                    inquiryType : "",
                    item        : null,
                    loading: false,
                    message     : null,
                    mileage     : mileage,
                    model       : null,
                    name        : name,
                    noOfOwners  : null,
                    phone       : phone,
                    regNumber   : regNumber,
                    registeredAt: null,
                    responseMessage : null,
                    responseStatus : null,
                    retailerId  : "",
                    rootEl : null,
                    status      : 'ready',
                    street      : street,
                    transmission: "",
                    userId      : email,
                    wheelDrive  : "",
                    year        : null,
                    zipcode     : zipcode,
                }
            },

            created()
            {
                this.rootEl = document.getElementById('js_priceEstimate');
                this.host = document.querySelector('[name="site_root"]').content;
                this.redirect = window.location.href;
                this.retailerId = this.rootEl.dataset.retailer_id ?? null;
                this.setupInquiryType();
                this.rootEl.classList.add('is-ready');
            },

            computed :
            {
                basicDetailsClass()
                {
                    return (this.item) ? ' toggled ' : '';
                },

                equipmentDetailsClass()
                {
                    return (this.equipmentDetailsToggled) ? ' active ' : '';
                }
            },

            methods:
            {
                getDatasetFromRootElement(attr) {
                    return (typeof this.rootEl.dataset[attr] !== 'undefined') ? this.rootEl.dataset[attr]: null;
                },

                getSelectedLabel(elementId) {
                    const el = document.getElementById(elementId);
                    const label = el.options[el.selectedIndex].text;
                    return (label !== 'Velg') ? label : '';
                },

                setupInquiryType() {
                    const inquiryType = this.getDatasetFromRootElement('inquiry_type');
                    this.inquiryType =  (typeof inquiryType === 'string' && this.rootEl.dataset.inquiry_type.length >0) ?
                        this.rootEl.dataset.inquiry_type :
                        'estimation' ;
                },

                prepareData() {
                    const token = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');

                    const bodyFormData = new FormData();
                    const productData = {
                        'Merke'             : this.getSelectedLabel('brand'),
                        'Modell'            : this.model,
                        'Regnr'             : this.regNumber,
                        'Understellsnummer' : this.item.unr,
                        'Førstegangsregistrert' : this.registeredAt,
                        'Kilometerstand'    : this.mileage,
                        'Antall eiere'      : this.noOfOwners,
                        'Årsmodell'         : this.year,

                        // get name of selected option
                        'Drivstoff'         : this.getSelectedLabel('fuel'),
                        'Girkasse'          : this.getSelectedLabel('transmission'),
                        'Hjuldrift'         : this.getSelectedLabel('wheel_drive'),
                        'Utstyr'            : (this.equipment.length) ? this.equipment.join() : '',
                    };

                    const subject = this.inquiryType === 'purchase' ? 'kommisjon' : 'prisantydning';

                    const postArgs = {
                        reg_number : this.regNumber,
                        name: this.name,
                        city: this.city,
                        email: this.userId,
                        gdpr: this.gdpr ? 1 : 0,
                        phone: this.phone,
                        data: JSON.stringify(productData),
                        honeypot: document.getElementById('email').value,
                        message: this.message,
                        retailerId: this.retailerId,
                        redirect: this.redirect,
                        street: this.street,
                        subject: subject,
                        type: this.inquiryType,
                        zipcode: this.zipcode
                    };

                    console.log(postArgs);

                    for (let key in postArgs) {
                        bodyFormData.append(key, postArgs[key]);
                    }

                    // bodyFormData.append('reg_number', this.regNumber);
                    // bodyFormData.append('name', this.name);
                    // bodyFormData.append('city', this.city);
                    // bodyFormData.append('email', this.userId);
                    // bodyFormData.append('gdpr', (this.gdpr) ? 1 : 0);
                    // bodyFormData.append('phone', this.phone);
                    // bodyFormData.append('data', JSON.stringify(productData));
                    // bodyFormData.append('honeypot', document.getElementById('email').value);
                    // bodyFormData.append('message', this.message);
                    // bodyFormData.append('retailerId', this.retailerId);
                    // bodyFormData.append('redirect', this.redirect);
                    // bodyFormData.append('street', this.street);
                    // bodyFormData.append('subject', 'Henvendelse for prisantydning');
                    // bodyFormData.append('type', 'estimation');
                    // bodyFormData.append('zipcode', this.zipcode);

                    if (typeof this.attachment.files[0] !== 'undefined') {
                        bodyFormData.append('attachment', this.attachment.files[0]);
                    }

                    // console.log('PRODUCT DATA');
                    // console.log(productData);
                    return bodyFormData;
                },

                validateAttachment(){
                    this.attachment = this.$refs.attachment;
                    const file = this.$refs.attachment.files[0];
                    let status = true;

                    const limit = 1024 * 1024 * 5;
                    if (file && file.size > limit) {
                        status = false;
                        this.classAttachment = 'error';
                    }

                    return status;
                },

                onSubmit(){
                    this.responseStatus = '';
                    this.responseMessage = '';
                    this.classAttachment = '';

                    if (this.validateAttachment()) {
                        this.xhrActive = true;
                        const url = '/actions/ck/mail/store';
                        const postData = this.prepareData();
                        this.restPost(url, postData, 'onSubmit__callback', 'onSubmit__error');
                    } else {
                        this.responseStatus = 'error';
                        this.responseMessage = 'Bildet er for stort (maks 5 MB)';

                        const formHeader = document.querySelector("#js_productEstimate");
                        formHeader.scrollIntoView({block: "start", behavior: "smooth"});
                    }
                },

                onSubmit__callback(response) {
                    if (typeof response === 'object' && typeof response.data === 'object') {
                        this.responseStatus = 'ok';
                        this.responseMessage = response.data.message;
                    }

                    this.scrollToForm();
                },

                onSubmit__error(error) {
                    this.responseStatus = 'error';
                    this.responseMessage = error;
                    this.scrollToForm();
                },

                scrollToForm() {
                    const el = document.getElementById('js_priceEstimate');
                    el.style.top = (el.offsetTop-16)+"px";
                    el.scrollIntoView({block: "start", behavior: "smooth"});
                },

                toggleEquipmentDetails() {
                    this.equipmentDetailsToggled = !this.equipmentDetailsToggled;
                },

                findRegNumber() {
                    this.loading = true;
                    this.regNumber = this.regNumber.replaceAll(' ', '');
                    const endpoint = '/actions/ck/price-estimate/get-regnumber';
                    const queryArgs = { reg_number : this.regNumber };

                    this.rest(endpoint, queryArgs, 'findRegNumber__callback');
                },

                findRegNumber__callback(response) {
                    // console.log("findRegNumber__calback");
                    // console.log(response.data);
                    if (response.data.item && typeof response.data.item === 'object') {
                        this.item = response.data.item;
                        this.year = this.item.year;
                        this.model = this.item.modell;
                        this.fuel = this.item.drivst;
                        this.registeredAt = this.item.registered_at;
                        this.transmission = this.item.transmission;
                        this.brand = this.item.brand.id;
                        this.brandList = this.item.brandList;
                        this.equipmentList = this.item.equipment;
                    } else {
                        this.responseStatus = 'error';
                        this.responseMessage = 'Registreringsnummert ble ikke funnet';
                    }
                },

                rest : function(endpoint, queryArgs, callback) {
                    this.loading = true;
                    this.responseStatus = this.responseMessage = null;

                    let queryString = "";
                    for (let i in queryArgs) {
                        queryString += i + "=" + queryArgs[i]+"&";
                    }
                    const url = this.host + endpoint + "?" + queryString;

                    axios.get(url)         
                        .then(this[callback])
                        .catch(function (error) {
                            this.loading = false;
                        })
                        .finally(data => {
                            this.loading = false;
                        });;
                },

                restPost(endpoint, queryArgs, callback,  callback__error) {
                    this.loading = true;
                    const headers = { "Content-Type": "multipart/form-data" };

                    const url = this.host + endpoint;
                    axios.post(url, queryArgs, headers)
                    .then(this[callback])
                    .catch(this[callback__error])
                    .finally(data => {
                        this.loading = false;
                    });
                }
            }
        }).mount('#js_priceEstimate');

    }
}